import React, { useState } from 'react';
import TabsChuyenThu from './Tabs.ChuyenThu';
import TabsPhieuGui from './Tabs.PhieuGui';
import TabsBangKe from './Tabs.BangKe';
import TabsTuiThu from './Tabs.TuiThu';
import TabsBuuCuc from './Tabs.BuuCuc';

export default (props) => {
  let tabs;
  switch (props.type) {
    case 'CHUYEN_THU':
      tabs = <TabsChuyenThu data={props.data} />;
      break;
    case 'PHIEU_GUI':
      tabs = <TabsPhieuGui data={props.data} />;
      break;
    case 'BANG_KE':
      tabs = <TabsBangKe data={props.data} />;
      break;
    case 'TUI_THU':
      tabs = <TabsTuiThu data={props.data} />;
      break;
    case 'BUU_CUC':
      tabs = <TabsBuuCuc data={props.data} />;
      break;
    default:
      break;
  }

  return <>{tabs}</>;
};
